import {isString, cloneDeep} from 'lodash';

import requester from 'Services/requester/requester';
import mainConfig from 'mainConfig';

const TOMTOM_ORIGIN = 'api.tomtom.com';

class TierStyleRetriever {
    constructor() {
        this._cache = {};
    }

    _getOrigin = () => mainConfig.origin;

    _transformResponse = (response) => {
        return JSON.parse(response.replace(new RegExp(TOMTOM_ORIGIN, 'g'), this._getOrigin()));
    }

    _download = async (styleUrl) => {
        const options = {url: styleUrl};

        if (this._getOrigin() !== TOMTOM_ORIGIN) {
            return await requester.get(options, this._transformResponse);
        }

        return await requester.get(options);
    };

    fetch = async (tier) => {
        const styleUrl = tier.getStyle();
        if (!isString(styleUrl)) {
            return tier;
        }

        let stylePromise = this._cache[styleUrl];
        if (!stylePromise) {
            stylePromise = this._download(styleUrl);
            this._cache[styleUrl] = stylePromise;
        }
        const style = await stylePromise;
        tier.setStyle(cloneDeep(style));
        return tier;
    };

    fetchAll = async (tiers) => {
        return Promise.all(tiers.map(tier => this.fetch(tier)));
    }
}

export default () => {
    return new TierStyleRetriever();
};



// WEBPACK FOOTER //
// ./map/map/tierStyleRetriever.js